// we get this JSON from https://api.crowdin.com/api/supported-languages?json=true
// we do not want to load it each time because it takes time and file almost never change
import crowdinLanguages from './crowdin-supported-languages.json';
const mapLocaleToCrowdingCode = (languages) => languages.reduce((acc, item) => {
    acc[item.locale] = item.crowdin_code;
    return acc;
}, {});
const localeToCrowdinKeyMap = mapLocaleToCrowdingCode(crowdinLanguages);
export const getCrowdinCode = (locale) => localeToCrowdinKeyMap[locale] || locale;
